import { SMSTemplatedType } from '@/types'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { getSMSTemplatedMessage } from '@/lib/api/templated-messages'
import { Button } from '@/components/ui/button'
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import {
  DialogClose,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog'
import EditSMSForm from '@/components/forms/edit-sms-form'

export const Route = createFileRoute('/_home/message-templates/sms/edit')({
  component: EditSMSPage,
})

export default function EditSMSPage({
  smsTemplatedMessage,
  setShowEditSMSTemplatedModal,
}: {
  smsTemplatedMessage: SMSTemplatedType
  setShowEditSMSTemplatedModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      {/*       <DialogContent className="md:max-w-[750px]">
        <EditSMSForm />
        <DialogFooter className="flex flex-row justify-end gap-2 md:mr-4">
          <DialogClose>
            <Button variant="outline" type="submit" className="w-28">
              Cancel
            </Button>
          </DialogClose>
          <Button type="submit" className="w-28">
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent> */}

      <CredenzaContent className="flex w-full max-w-[750px] justify-center">
        <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
          <EditSMSForm
            setShowSMSTemplatedModal={setShowEditSMSTemplatedModal}
            smsTemplatedMessage={smsTemplatedMessage}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
